<template>
    <MainPage @clickBack="clickBack()">
        <div class="max-w-4xl m-auto mb-20">
            <div class="pt-6 p-4 lg:p-6 lg:border border-a-brown-d7c7b8 rounded-20">
                <PdpaContent
                    :type="type"
                    :localeCode="localeCode"
                    @onError="onError($event)" />
            </div>
        </div>
    </MainPage>
</template>
<script>
// mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
// component
import MainPage from "@/components/Layout/Page/MainPage.vue";
import PdpaContent from '@/components/Authen/Pdpa/PdpaContent.vue';
export default {
    name: 'Pdpa',
    mixins: [LocaleMixin, ModalMixin],
    components: {
        MainPage,
        PdpaContent,
    },
    data: function () {
        return {
            type: 'terms'
        };
    },
    created: function () {
        this.type = this.$route.name;
    },
    methods: {
        getTitle: function(){
            return this.type == 'terms' ? this.lbl.pdpa.terms_title : this.lbl.pdpa.privacy_title;
        },
        clickBack: function(){
            this.$router.back();
        },
        onError: function (error) {
            this.errorApi(error);
        }
    }
}
</script>
